// Partnership bidding - talks to the partnerBidding Cloud Function (Paul, 16 Oct 2026).
// On localhost it uses the local Functions emulator; "?as=<test id>" there plays as a test
// partner without signing in (the emulator is the only place that accepts it).
import { firebase } from "../../firebase/config";

const isLocal = typeof window !== "undefined" && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
// REACT_APP_PB_EMULATOR_PORT lets a local test run use an emulator on another port (default 5001).
const URL = isLocal
  ? `http://127.0.0.1:${process.env.REACT_APP_PB_EMULATOR_PORT || 5001}/bridgechampions/us-central1/partnerBidding`
  : "https://us-central1-bridgechampions.cloudfunctions.net/partnerBidding";

export function testUid() {
  if (!isLocal) return null;
  try {
    const q = new URLSearchParams(window.location.search).get("as");
    if (q) sessionStorage.setItem("pb-as", q);
    return sessionStorage.getItem("pb-as");
  } catch (e) {
    return null;
  }
}

export async function pb(action, args = {}) {
  const headers = { "Content-Type": "application/json" };
  const as = testUid();
  if (as) headers["X-Test-Uid"] = as;
  else {
    const user = firebase.auth().currentUser;
    if (!user) throw new Error("Please sign in to bid with a partner.");
    headers.Authorization = `Bearer ${await user.getIdToken()}`;
  }
  let r;
  try {
    r = await fetch(URL, { method: "POST", headers, body: JSON.stringify({ action, ...args }) });
  } catch (e) {
    throw new Error("Couldn't reach the server. Check your connection and try again.");
  }
  const j = await r.json().catch(() => ({}));
  if (!j.ok) throw new Error(j.error || "Something went wrong. Please try again.");
  return j;
}
